import { DoubleSide } from 'three'
import { rotacaoYAFavorDoVento } from '../../dominio/vento'

export interface PropsBiruta3D {
  posicao: readonly [number, number]
  direcaoVentoGraus: number
  velocidadeMS: number
  alturaM?: number
}

/**
 * Biruta: mastro e manga listrada apontando a favor do vento. A manga
 * levanta com a velocidade — pendurada em calmaria, horizontal a partir de
 * ~8 m/s —, que é a leitura que o bombeiro faz na cena.
 */
export function Biruta3D({ posicao, direcaoVentoGraus, velocidadeMS, alturaM = 6 }: PropsBiruta3D) {
  const inclinacao = (Math.min(1, velocidadeMS / 8) * Math.PI) / 2
  const comprimentoManga = 2.2
  const segmentos = 5
  return (
    <group position={[posicao[0], 0, posicao[1]]}>
      <mesh position={[0, alturaM / 2, 0]} castShadow>
        <cylinderGeometry args={[0.05, 0.07, alturaM, 10]} />
        <meshStandardMaterial color="#d0d4d8" metalness={0.6} roughness={0.4} />
      </mesh>
      <group position={[0, alturaM, 0]} rotation={[0, rotacaoYAFavorDoVento(direcaoVentoGraus), 0]}>
        {/* +Z local aponta a favor do vento; a manga cai de "pendurada" (−Y) até horizontal (+Z) */}
        <group rotation={[Math.PI / 2 - inclinacao, 0, 0]}>
          {Array.from({ length: segmentos }, (_, i) => {
            const t0 = i / segmentos
            const r0 = 0.32 * (1 - t0 * 0.55)
            const r1 = 0.32 * (1 - (t0 + 1 / segmentos) * 0.55)
            return (
              <mesh key={i} position={[0, 0, comprimentoManga * (t0 + 0.5 / segmentos)]} rotation={[Math.PI / 2, 0, 0]} castShadow>
                <cylinderGeometry args={[r1, r0, comprimentoManga / segmentos, 16, 1, true]} />
                <meshStandardMaterial color={i % 2 === 0 ? '#f05a1a' : '#f4f4f4'} side={DoubleSide} roughness={0.8} />
              </mesh>
            )
          })}
        </group>
      </group>
    </group>
  )
}
